export const contact_data = [
  {
    id: "1",
    image:"assets/img/users/user-33.png",
    Name: "Carl Evans",
    Email: "carlevans@example.com",
    Phone: "+12163547758",
    Role: "Admin",
    Status: "Active",
  },
  {
    id: "2",
    image:"assets/img/users/user-02.jpg",
    Name: "Minerva Rameriz",
    Email: "rameriz@example.com",
    Phone: "+11367529510",
    Role: "Manager",
    Status: "Active",
  },
  {
    id: "3",
    image:"assets/img/users/user-34.jpg",
    Name: "Robert Lamon",
    Email: "robert@example.com",
    Phone: "+15362789414",
    Role: "Salesman",
    Status: "Active",
  },
  {
    id: "4",
    image:"assets/img/users/user-35.jpg",
    Name: "Patricia Lewis",
    Email: "patricia@example.com",
    Phone: "+18513094627",
    Role: "Supervisor",
    Status: "Active",
  },
  {
    id: "5",
    image:"assets/img/users/user-36.jpg",
    Name: "Mark Joslyn",
    Email: "markjoslyn@example.com",
    Phone: "+14678219025",
    Role: "Store Keeper",
    Status: "Active",
  },
  {
    id: "6",
    image:"assets/img/users/user-37.jpg",
    Name: "Marsha Betts",
    Email: "marshabetts@example.com",
    Phone: "+10913278319",
    Role: "Purchase",
    Status: "Active",
  },
  {
    id: "7",
    image:"assets/img/users/user-28.jpg",
    Name: "Daniel Jude",
    Email: "daieljude@example.com",
    Phone: "+19125852947",
    Role: "Delivery Biker",
    Status: "Active",
  },
  {
    id: "8",
    image:"assets/img/users/user-38.jpg",
    Name: "Emma Bates",
    Email: "emmabates@example.com",
    Phone: "+13671835209",
    Role: "Maintenance",
    Status: "Active",
  },
  {
    id: "9",
    image:"assets/img/users/user-39.jpg",
    Name: "Richard Fralick",
    Email: "richard@example.com",
    Phone: "+19756194733",
    Role: "Quality Analyst",
    Status: "Active",
  },
  {
    id: "10",
    image:"assets/img/users/user-40.jpg",
    Name: "Michelle Robison",
    Email: "robinson@example.com",
    Phone: "+19167850925",
    Role: "Accountant",
    Status: "Active",
  },
];
